<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="row"
		*ngIf="loading">
		<div class="icon-loading">
			<span>
				<i class="fa fa-circle-notch fa-spin fa-2x"></i>
			</span>

		</div>
	</div>
	<div
		class="modal-body"
		*ngIf="!loading"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && employee">
			<div class="col-sm-12">
				<div class="row">
					<!-- company -->
					<div class="form-group col-md-4">
						<label for="company">{{ 'labels.company' | translate }}*</label>
						<ng-template [ngIf]="companyid">
							<input
								name="companyinput"
								[placeholder]="selected.company?.name"
								required
								type="text"
								class="form-control"
								id="companyinput"
								disabled>
						</ng-template>
						<ng-template [ngIf]="!companyid">
							<app-entity-autocomplete
								entityName="company"
								entityField="name"
								entityFilterType="like"
								[entitySearch]="search.company"
								name="company"
								[(ngModel)]="selected.company"
								placeholder
								required
								#companyautocomp="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && companyautocomp.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="!companyid && editForm.submitted && companyautocomp.invalid"
								style="display: block;">
								{{'errors.required' | translate}}
							</div>

						</ng-template>
					</div>
					<!-- fname -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.fname' | translate }}*</label>
						<input
							[(ngModel)]="employee.fname"
							#fname="ngModel"
							name="fname"
							required
							type="text"
							class="form-control"
							id="fname"
							placeholder="{{ 'labels.fname' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && fname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && fname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- lname -->
					<div class="form-group col-md-4">
						<label for="cname">{{ 'labels.lname' | translate }}*</label>
						<input
							[(ngModel)]="employee.lname"
							#lname="ngModel"
							name="lname"
							required
							type="text"
							class="form-control"
							id="lname"
							placeholder="{{ 'labels.lname' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && lname.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && lname.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- matricola -->
					<div class="form-group col-md-4">
						<label>{{'labels.matricola' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="matricola"
							[(ngModel)]="employee.matricola"
							#matricola="ngModel"
							required
							[ngClass]="{'is-invalid': editForm.submitted && matricola.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && matricola.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- cf -->
					<div class="form-group col-md-4">
						<label for="cf">{{ 'labels.cf' | translate }}*</label>
						<input
							[(ngModel)]="employee.cf"
							#cf="ngModel"
							name="cf"
							required
							type="text"
							class="form-control"
							pattern="^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$"
							id="cf"
							placeholder="{{ 'labels.cf' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && cf.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && cf.invalid">
							{{'errors.invalid' | translate}}
						</div>
					</div>
					<!-- email -->
					<div class="form-group col-md-4">
						<label for="email">{{ 'labels.email' | translate }}</label>
						<input
							email
							[(ngModel)]="employee.email"
							#email="ngModel"
							name="email"
							type="email"
							class="form-control"
							id="email"
							placeholder="{{ 'labels.email' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && email.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && email.invalid">
							{{'errors.invalid' | translate}}
						</div>
					</div>
					<!-- mobileno -->
					<div class="form-group col-md-4">
						<label for="mobileno">{{ 'labels.mobileno' | translate }}</label>
						<input
							[(ngModel)]="employee.mobileno"
							#mobileno="ngModel"
							name="mobileno"
							type="text"
							class="form-control"
							id="mobileno"
							placeholder="{{ 'labels.mobileno' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && mobileno.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && mobileno.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- landline -->
					<div class="form-group col-md-4">
						<label for="landline">{{ 'labels.landline' | translate }}</label>
						<input
							[(ngModel)]="employee.landline"
							#landline="ngModel"
							name="landline"
							type="text"
							class="form-control"
							id="landline"
							placeholder="{{ 'labels.landline' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && landline.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && landline.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- address -->
					<div class="form-group col-md-4">
						<label>{{'labels.address' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="address"
							[(ngModel)]="employee.address"
							#address="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && address.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && address.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- streetno -->
					<div class="form-group col-md-4">
						<label>{{'labels.streetno' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="streetno"
							[(ngModel)]="employee.streetno"
							#streetno="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && streetno.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && streetno.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- country -->
					<div class="form-group col-md-4">
						<label>{{'labels.country' | translate}}</label>
						<app-entity-autocomplete
							(onSelected)="updateCountry()"
							(onDeleted)="updateCountry()"
							entityName="country"
							entityField="name"
							entityFilterType="like"
							[entitySearch]="search.nazione"
							[entityClass]="nazioneClass"
							name="nazione"
							[(ngModel)]="selected.nazione"
							placeholder
							#country="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && country.invalid}">
						</app-entity-autocomplete>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && country.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- province -->
					<div class="form-group col-md-4">
						<label>{{'labels.province' | translate}}</label>
						<ng-template [ngIf]="isItalia">
							<app-entity-autocomplete
								(onSelected)="updateProvince()"
								(onDeleted)="updateProvince()"
								entityName="province"
								entityField="descrizione"
								entityFilterType="like"
								[entitySearch]="search.provincia"
								name="provincia"
								#provinceautocomplete="ngModel"
								[(ngModel)]="selected.provincia"
								placeholder
								[ngClass]="{'is-invalid': editForm.submitted && provinceautocomplete.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && provinceautocomplete.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>
						<ng-template [ngIf]="!isItalia">
							<input
								[(ngModel)]="employee.province"
								[disabled]="!selected.nazione || !selected.nazione.id"
								#provinceinput="ngModel"
								name="provinceinput"
								type="text"
								class="form-control"
								placeholder="{{ 'labels.province' | translate }}"
								[ngClass]="{'is-invalid': editForm.submitted && provinceinput.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && provinceinput.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>

					</div>
					<!-- city -->
					<div class="form-group col-md-4">
						<label>{{'labels.comune' | translate}}</label>
						<ng-template [ngIf]="isItalia">
							<app-entity-autocomplete
								[disabled]="selected.provincia === undefined"
								entityName="comuni"
								entityField="descrizione"
								entityFilterType="like"
								[entitySearch]="search.comune"
								name="comune"
								[(ngModel)]="selected.comune"
								placeholder
								#cityautocomplete="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && cityautocomplete.invalid}">
							</app-entity-autocomplete>
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && cityautocomplete.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>
						<ng-template [ngIf]="!isItalia">
							<input
								[(ngModel)]="employee.city"
								[disabled]="!selected.nazione || !selected.nazione.id || !employee.province"
								#cityinput="ngModel"
								name="cityinput"
								type="text"
								class="form-control"
								placeholder="{{ 'labels.comune' | translate }}"
								[ngClass]="{'is-invalid': editForm.submitted && cityinput.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && cityinput.invalid">
								{{'errors.required' | translate}}
							</div>
						</ng-template>
					</div>
					<!-- zipcode -->
					<div class="form-group col-md-4">
						<label>{{'labels.zipcode' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="zipcode"
							[(ngModel)]="employee.zipcode"
							#zipcode="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && zipcode.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && zipcode.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- birthday -->
					<div class="form-group col-md-4">
						<label>{{'labels.birthday' | translate}}</label>
						<app-datepicker
							[(ngModel)]="employee.birthdate"
							name="birthday"
							#birthday="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && birthday.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && birthday.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- birthcity -->
					<div class="form-group col-md-4">
						<label>{{'labels.birthcity' | translate}}</label>
						<input
							type="text"
							class="form-control"
							name="birthcity"
							[(ngModel)]="employee.birthcity"
							#birthcity="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && birthcity.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && birthcity.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- contract -->
					<div class="form-group col-md-4">
						<label>{{'labels.contract' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="employee.contract"
							required
							#contract="ngModel"
							name="contract"
							[ngClass]="{'is-invalid': editForm.submitted && contract.invalid}">
							<option
								*ngFor="let contract of contracttypes"
								[value]="contract.itemvalue">
								{{contract.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && contract.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- contractlevel -->
					<div class="form-group col-md-4">
						<label>{{'labels.contractlevel' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="employee.contractlevel"
							required
							#contractlevel="ngModel"
							name="contractlevel"
							[ngClass]="{'is-invalid': editForm.submitted && contractlevel.invalid}">
							<option
								*ngFor="let contract of contractlevels"
								[value]="contract.itemvalue">
								{{contract.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && contractlevel.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- expyears -->
					<div class="form-group col-md-4">
						<label>{{'employee.expyears' | translate}}*</label>
						<input
							type="number"
							class="form-control"
							name="expyears"
							[(ngModel)]="employee.expyears"
							required
							#expyears="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && expyears.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && expyears.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- studylevel -->
					<div class="form-group col-md-4">
						<label>{{'labels.studylevel' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="employee.studylevel"
							required
							#studylevel="ngModel"
							name="studylevel"
							[ngClass]="{'is-invalid': editForm.submitted && studylevel.invalid}">
							<option
								*ngFor="let level of educationlevels"
								[value]="level.itemvalue">
								{{level.itemlabel}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && studylevel.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- studysubject -->
					<div class="form-group col-md-4">
						<label>{{'labels.studysubject' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="studysubject"
							[(ngModel)]="employee.studysubject"
							required
							#studysubject="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && studysubject.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && studysubject.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- jobposition -->
					<div class="form-group col-md-4">
						<label>{{'labels.jobposition' | translate}}*</label>
						<input
							type="text"
							class="form-control"
							name="jobposition"
							[(ngModel)]="employee.jobposition"
							required
							#jobposition="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && jobposition.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && jobposition.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<div class="col-md-4 mt-1">
						<div class="form-group">
							<div class="form-check form-check-inline">
								<input
									type="checkbox"
									class="form-check-input"
									name="active"
									[(ngModel)]="employee.partner">
								<label class="form-check-label">{{'labels.ispartner' | translate}}</label>
							</div>
						</div>
					</div>

					<!-- jobdescription -->
					<div class="form-group col-md-12">
						<label>
							{{'labels.jobdescription' | translate}}*
						</label>
						<textarea
							type="number"
							class="form-control"
							name="jobdescription"
							[(ngModel)]="employee.jobdescription"
							required
							#jobdescription="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && jobdescription.invalid}"></textarea>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && jobdescription.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>

	<div
		class="modal-footer"
		*ngIf="!loading">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>

</form>
